import React from 'react';
// Import Global Components
import { EditableCell, IconButton } from 'shared-components';
import Table from '../../../../components/Table';

export default function({ data, deleteData, errors, updateCell }) {
  const columns = [
    {
      Header: 'ID',
      accessor: 'id',
      show: false,
    },
    {
      Header: 'Email',
      accessor: 'email',
      className: 'cell',
      Cell: props => (
        <EditableCell
          name="email"
          updateCell={updateCell}
          className="email"
          error={errors[props.index][props.column.id]}
          {...props}
          type="email"
        />
      ),
    },
    {
      Header: 'Business Name',
      accessor: 'firstName',
      className: 'cell',
      Cell: props => (
        <EditableCell
          name="businessName"
          updateCell={updateCell}
          className="businessName"
          error={errors[props.index][props.column.id]}
          {...props}
        />
      ),
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      className: 'cell',
      minWidth: 150,
      maxWidth: 150,
      Cell: props => (
        <EditableCell
          name="amount"
          updateCell={updateCell}
          className="amount"
          {...props}
          error={errors[props.index][props.column.id]}
          prefix="$"
          placeholder="0.00"
        />
      ),
    },
    {
      Header: 'Notes',
      accessor: 'notes',
      className: 'cell',
      minWidth: 200,
      Cell: props => (
        <EditableCell
          name="notes"
          updateCell={updateCell}
          className="notes"
          maxLength="255"
          {...props}
          error={errors[props.index][props.column.id]}
        />
      ),
    },
    {
      minWidth: 32,
      maxWidth: 32,
      style: { margin: 'auto 0' },
      Cell: ({ index }) => (
        <IconButton
          iconType="delete"
          type="danger"
          variant="text"
          iconSize={15}
          onClick={deleteData.bind(this, index)}
        />
      ),
      sortable: false,
      filterable: false,
    },
  ];

  return <Table columns={columns} data={data} key="create-transfer-table" />;
};
